import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { compose } from 'recompose'
import { withJsonApiProps, withLayout } from 'utils'
import { ApplicationLayout } from 'components'

const propTypes = {}
const defaultProps = {}

function Final() {
  const [rating, setRating] = useState(0)
  const [hovered, setHovered] = useState(0)
  const [comment, setComment] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async () => {
    if (rating === 0) return
    setSubmitting(true)
    try {
      await fetch('/user_rating', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_rating: rating, user_comments: comment }),
      })
    } catch (e) {
      // non-blocking
    }
    setSubmitted(true)
    setSubmitting(false)
  }

  return (
    <>
      <Helmet>
        <title>Application Complete</title>
      </Helmet>

      {/* Header row: h1 left, download button right */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem', marginBottom: '0.5rem' }} className="page-header">
        <h1 style={{ margin: 0 }}>Application Complete</h1>
        <a
          href="/pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
          style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download PDF
        </a>
      </div>

      <div className="info-container" style={{ display: 'flex', flexDirection: 'column' }}>

        {/* Message below heading */}
        <p style={{ marginBottom: '1rem', lineHeight: 1.5 }}>
          Your application has been submitted successfully. You may review and
          download a copy of your completed application below.
        </p>

        {/* PDF iframe */}
        <iframe
          src="/pdf"
          title="Your completed application"
          style={{
            width: '100%',
            height: '80vh',
            border: 'none',
            display: 'block',
            borderRadius: '4px',
          }}
        />

        {/* Rating widget */}
        <div
          style={{
            marginTop: '2rem',
            padding: '1.5rem 1rem',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            background: '#fafafa',
            textAlign: 'center',
            maxWidth: '480px',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '100%',
          }}
        >
          {submitted ? (
            <p style={{ fontSize: '1rem', color: '#2a7a4b', fontWeight: 500, margin: 0 }}>
              ✓ Thank you for your feedback!
            </p>
          ) : (
            <>
              <p style={{ fontWeight: 600, marginBottom: '0.75rem', fontSize: '1rem' }}>
                How was your experience?
              </p>
              <div style={{ marginBottom: '0.75rem' }}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHovered(star)}
                    onMouseLeave={() => setHovered(0)}
                    style={{
                      cursor: 'pointer',
                      fontSize: '2rem',
                      lineHeight: 1,
                      color: star <= (hovered || rating) ? '#f5a623' : '#d0d0d0',
                      transition: 'color 0.1s',
                      padding: '0 2px',
                      userSelect: 'none',
                    }}
                    role="button"
                    aria-label={`Rate ${star} star${star > 1 ? 's' : ''}`}
                  >
                    ★
                  </span>
                ))}
              </div>
              <textarea
                placeholder="Any additional comments? (optional)"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                maxLength={255}
                rows={3}
                style={{
                  width: '100%',
                  padding: '0.5rem 0.6rem',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  fontSize: '0.85rem',
                  resize: 'vertical',
                  marginBottom: '0.75rem',
                  display: 'block',
                  boxSizing: 'border-box',
                }}
              />
              <button
                onClick={handleSubmit}
                disabled={rating === 0 || submitting}
                className="btn btn-primary"
                style={{ width: '100%' }}
              >
                {submitting ? 'Submitting...' : 'Submit Feedback'}
              </button>
            </>
          )}
        </div>

      </div>
    </>
  )
}

Final.propTypes = propTypes
Final.defaultProps = defaultProps

export default compose(
  withJsonApiProps(),
  withLayout(ApplicationLayout)
)(Final)
